import { jwtDecode } from "jwt-decode";

const useRole = () => {
  const token = localStorage.getItem("token");

  const getRole = () => {
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      return decoded.role; // Assuming the JWT contains a `role` field
    } catch (err) {
      console.error("Error decoding token:", err);
      return null;
    }
  };

  const hasRole = (role) => {
    const userRole = getRole();
    return userRole === role;
  };

  return { getRole, hasRole };
};

export default useRole;
